<template lang="pug">
    section.ai-face-swap-funny.section
        ._wrap.wrap
            h2._title {{ content.title }}
            ._box
                portal._box-image-container(to="image-1" :disabled="pageWidth >= 900")
                    img(src="../../../assets/images/ai-face-swap-funny/1.png")._box-image
                ._box-info
                    ._box-title
                        portal-target(name="image-1")._box-image-container
                        span {{ content.boxes[0].title }}
                    
                    ._box-description
                        p._box-p(v-for="(text, index) in content.boxes[0].paragraphs" :key="index") {{ text }}
            ._box
                ._box-info
                    ._box-title
                        portal-target(name="image-2")._box-image-container
                        span {{ content.boxes[1].title }}
                    ._box-description
                        p._box-p(v-for="(text, index) in content.boxes[1].paragraphs" :key="index") {{ text }}
                portal._box-image-container(to="image-2" :disabled="pageWidth >= 900")
                    img(src="../../../assets/images/ai-face-swap-funny/2.png")._box-image
</template>

<script>
import aiStatic from "@/seo/ai-static.json";

export default {
    name: "AiFaceSwapFunny",
    data() {
        // Текст лежит в ai-static.json: тот же файл использует выгрузка HTML для поисковых ботов
        return { content: aiStatic.faceSwapFunny };
    },
};
</script>

<style lang="scss" src="./ai-face-swap-funny.scss"></style>
